import OnsiteContactDetailPage from "@/app/(app)/(crew)/supervising/[shift]/contact";

export default OnsiteContactDetailPage;
